import { Button, Col, DeleteButton, EditButton, Form, getDefaultSortOrder, Icons, Input, List, Row, Space, Table, TextField, useTable } from '@pankod/refine-antd';
import { CrudFilters, IResourceComponentsProps, useTranslate } from '@pankod/refine-core';
import { ButtonExport } from 'components/buttonExport';
import useMediaScreen from 'hooks/useMediaScreen';
import React from 'react';
import { ICrate, ICrateResponse } from 'types/crate.interface';
import { getOrderNumber } from 'utils';

export const CrateList: React.FC<IResourceComponentsProps> = () => {
    const t = useTranslate();
    const { isMobile } = useMediaScreen();
    const { tableProps, sorter, searchFormProps }: any = useTable<ICrateResponse>({
        resource: 'crates',
        initialPageSize: 100,
        onSearch: (params) => {
            const filters: CrudFilters = [];
            const input = params;
            filters.push({
                field: 'search',
                operator: 'in',
                value: input,
            });
            return filters;
        },
    });
    const current = tableProps?.pagination?.current;
    const pageSize = tableProps?.pagination?.pageSize;

    return (
        <List>
            <Row style={{ display: 'block' }}>
                <Col>
                    <Form layout='vertical' {...searchFormProps}>
                        <Form.Item label='Search' name='search' style={{ width: isMobile ? "100%" : '50%' }} initialValue=''>
                            <Input placeholder='Name, Username' prefix={<Icons.SearchOutlined />} />
                        </Form.Item>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Form.Item>
                                <Button htmlType='submit' type='primary'>
                                    Filter
                                </Button>
                            </Form.Item>
                            <ButtonExport path='crates' />
                        </div>
                    </Form>
                </Col>
                <Col>
                    <Table
                        {...tableProps}
                        pagination={{
                            ...tableProps?.pagination,
                            showSizeChanger: true,
                        }}
                        rowKey='id'
                    >
                        <Table.Column dataIndex='_id' key='_id' title='Index' render={(value, item, index) => <TextField value={getOrderNumber(current, pageSize, index)} />} />
                        <Table.Column
                            dataIndex='name'
                            key='name'
                            title='Name'
                            render={(value) => <TextField value={value} />}
                            defaultSortOrder={getDefaultSortOrder('name', sorter)}
                            sorter
                        />

                        <Table.Column
                            dataIndex='user'
                            key='user'
                            title='User'
                            render={(value) => <TextField value={value.email} />}
                            defaultSortOrder={getDefaultSortOrder('user', sorter)}
                            sorter
                        />

                        <Table.Column<ICrate>
                            title={t('table.actions')}
                            dataIndex='actions'
                            render={(_, record) => (
                                <Space>
                                    <EditButton hideText size='small' recordItemId={record._id} />
                                    <DeleteButton hideText size='small' recordItemId={record._id} />
                                </Space>
                            )}
                        />
                    </Table>
                </Col>
            </Row>
        </List>
    );
};
